module.exports = __webpack_public_path__ + "img/avatar-24.6ccddf73.png";